<template>
  <div>
    <div
      v-for="(towerCell, index) in data"
      :key="index"
      class="TowerCells"
    >
      <div class="towerCells__blocTitle">
        <div class="towerCells__blocTitle__titleModal">
          {{ $t(`technicalFile.cooling.step3.titleWithIndex`, { index: index + 1 }) }}
        </div>
        <v-btn
          v-if="data.length > 1"
          fab
          xSmall
          color="secondary"
          class="ml-3"
          @click="deleteTowerCell(index)"
        >
          <v-icon color="#ffffff">
            mdi-delete
          </v-icon>
        </v-btn>
      </div>

      <v-row>
        <v-col class="noYPadding">
          <VTextField
            v-model="towerCell.descriptionIdentifier"
            :label="$t('technicalFile.cooling.step3.description')"
            class="text-field-transparent"
            outlined
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="noYPadding">
          <VSelect
            v-model="towerCell.type"
            :label="$t('technicalFile.cooling.step3.type')"
            :items="displayedUnits('towerCellsType')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            :required="true"
            flat
            data-cy="towerCellsType"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="noYPadding">
          <VAutocomplete
            v-model="towerCell.towerMetallurgy"
            :label="$t('technicalFile.cooling.step3.towerMetallurgy')"
            :items="displayedUnits('towerMetallurgy')"
            :multiple="true"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            flat
            data-cy="towerMetallurgy"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="noYPadding">
          <VTextField
            v-model="towerCell.model"
            :label="$t('technicalFile.cooling.step3.model')"
            class="text-field-transparent"
            outlined
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="noYPadding"
          cols="12"
          sm="8"
          md="4"
        >
          <VTextField
            v-model="towerCell.coolingCapacity.value"
            :label="$t('technicalFile.cooling.step3.coolingCapacity')"
            :formatNumber="true"
            type="number"
            min="0"
            class="text-field-transparent"
            outlined
            flat
            @input="updateData"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="2"
          class="noYPadding"
        >
          <VSelect
            v-model="towerCell.coolingCapacity.units"
            :label="$t('technicalFile.cooling.step3.units')"
            :items="displayedUnits('coolingCapacity')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            flat
            data-cy="coolingCapacity"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="noYPadding">
          <VAutocomplete
            v-model="towerCell.fillType"
            :label="$t('technicalFile.cooling.step3.fillType')"
            :items="displayedUnits('fillType')"
            :multiple="true"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            flat
            data-cy="fillType"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="noYPadding">
          <VSelect
            v-model="towerCell.coldSumpType"
            :label="$t('technicalFile.cooling.step3.coldSumpType')"
            :items="displayedUnits('coldSumpType')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            flat
            data-cy="coldSumpType"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="noYPadding">
          <VSelect
            v-model="towerCell.driftEliminators"
            :label="$t('technicalFile.cooling.step3.driftEliminators')"
            :items="displayedUnits('yesOrno')"
            class="text-field-transparent"
            itemValue="key"
            itemText="name"
            outlined
            flat
            data-cy="driftEliminators"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="index === data.length - 1"
      >
        <v-col
          cols="2"
          class="btn-container noYPadding"
        >
          <v-btn
            fab
            xSmall
            :color="data.length !== maxTowerCells ? 'secondary' : '#666666' "
            class="ml-3"
            @click="addTowerCell"
          >
            <v-icon color="#ffffff">
              mdi-plus
            </v-icon>
          </v-btn>
          <p
            style="padding-left: 10px"
            class="messageAsideButton"
          >
            {{ data.length !== maxTowerCells ? $t(`technicalFile.cooling.step3.titleWithIndex`, { index: index + 2, })
              : $t(`technicalFile.cooling.step3.messageMaxTowerReached`) }}
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect';

export default {
    name: 'TowerCells',
    components: {
        VTextField,
        VSelect,
    },
    props: {
        towerCells: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: [],
            maxTowerCells: 5,
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        towerCells: {
            handler() {
                this.data = [...this.data, ...cloneDeep(this.towerCells)];
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { towerCells: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
        getEmptyObject() {
            return {
                description: '',
                type: '',
                towerMetallurgy: [],
                model: '',
                coolingCapacity: {
                    value: '',
                    units: '',
                },
                fillType: [],
                coldSumpType: '',
                driftEliminators: '',
            };
        },
        addTowerCell() {
            if (this.data.length < this.maxTowerCells) {
                this.data.push(this.getEmptyObject());
            }
        },
        deleteTowerCell(index) {
            this.data.splice(index, 1);
            this.$emit('sendData', { towerCells: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.btn-container {
  display: flex;
  align-items: baseline;
  padding: 0;
}
.noYPadding {
  padding-bottom: 0;
  padding-top: 0;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
.messageAsideButton {
  white-space: nowrap;
}
.towerCells{
  &__blocTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center !important;
    margin-bottom: 20px;

    &__titleModal {
      font-size: 1.5rem;
    }
  }
}
</style>
